var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('drop-file',{staticClass:"dialog-drop-file",style:({backgroundColor: 'white'}),on:{"rawFilesChanged":function($event){_vm.$store.dispatch('dialog/setData', $event)}}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f651202e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/dialog/types/DialogUploadFiles.vue
// module id = 1379
// module chunks = 22